import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const HomeScreen = ({ backgroundImage, redBackgroundImage }) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          src={getImageFromS3('images/sms-mrl-ks/head.png')}
          alt="head-image"
          className={styles.headImage}
        />
        <div className={styles.formatTitle}>у “Кінг сайз” форматі</div>
        <div className={styles.characteristicContainer}>
          <div
            className={styles.filterContainer}
            style={{ backgroundImage: redBackgroundImage }}
          >
            <img
              src={getImageFromS3('images/sms-mrl-ks/filter.png')}
              alt="filter"
            />
            <p className={styles.title}>Firm filter</p>
            <p className={styles.description}>
              Ущільнений ацетатний фільтр, який краще тримає форму та менше
              розмокає
            </p>
          </div>
          <div
            className={styles.tobaccoContainer}
            style={{ backgroundImage: redBackgroundImage }}
          >
            <img
              src={getImageFromS3('images/sms-mrl-ks/tobacco.png')}
              alt="filter"
            />
            <p className={styles.title}>Selected premium tobaccos</p>
            <p className={styles.description}>
              Відбірна суміш тютюну від Мальборо
            </p>
          </div>
          <div
            className={styles.factoryContainer}
            style={{ backgroundImage: redBackgroundImage }}
          >
            <img
              src={getImageFromS3('images/sms-mrl-ks/factory.png')}
              alt="filter"
            />
            <p className={styles.title}>Вироблено</p>
            <p className={styles.description}>на власній фабриці в Україні</p>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>Де купити?</p>
          <p className={styles.description}>
            <b>Marlboro Red</b> та <b>Marlboro Gold</b> можна знайти у
            роздрібних точках продажу в твоєму місті або на офіційних онлайн
            сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <div>
              <a
                href="https://rozetka.com.ua/ua/sigareti/c4638591/producer=marlboro/?utm_source=PMUsmsMrlbKSCDA"
                target="_blank"
                onClick={() => sendEvent('rozetka')}
              >
                Rozetka
              </a>
            </div>
            <div>
              <a
                href="https://cig-poshta.in.ua/product-tag/marlboro-red-ta-gold/?utm_source=marlborosendoutcda"
                target="_blank"
                onClick={() => sendEvent('Cig-Poshta')}
              >
                Cig-poshta
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-mrl-ks">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
